import { render } from "./RoleView.vue?vue&type=template&id=1ca92398"
import script from "./RoleView.vue?vue&type=script&lang=js"
export * from "./RoleView.vue?vue&type=script&lang=js"
script.render = render

export default script